import {SecureStoragePlugin} from 'capacitor-secure-storage-plugin';
import {type StorageLikeAsync} from '@vueuse/core';

const requestsInProgress = new Set<Promise<unknown>>();

async function trackRequest<T>(promise: Promise<T>): Promise<T> {
    requestsInProgress.add(promise);
    try {
        return await promise;
    } finally {
        requestsInProgress.delete(promise);
    }
}

export const capacitorStorage: StorageLikeAsync = {
    async getItem(key) {
        return trackRequest(
            SecureStoragePlugin.get({key})
                .then(({value}) => value)
                .catch(() => null)
        );
    },
    async setItem(key, value) {
        return trackRequest(SecureStoragePlugin.set({key, value}).then(() => {}));
    },
    async removeItem(key) {
        return trackRequest(
            SecureStoragePlugin.remove({key})
                .then(() => {})
                .catch(() => {})
        );
    },
};

export async function allRequestsSettled() {
    if (requestsInProgress.size === 0) {
        return;
    }
    await Promise.allSettled([...requestsInProgress]);
}
